import { CUSTOMER_ANALYTICS_EVENT } from "../../utils/enums";
import { useCustomerAnalytics } from "./useCustomerAnalytics";
import { useAppSelector } from "./useReduxHooks";

export const useCategoryBarLogic = () => {
  const addCustomerAnalytics = useCustomerAnalytics();
  const isFranchiseOpen = useAppSelector(
    (store) => store.franchiseStatus.currentIsOpen
  );
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);
  const isMainDark = restaurantInfo?.colors?.theme === "main_dark";

  const scrollToCategory = (
    e: React.MouseEvent<HTMLAnchorElement>,
    barId: string,
    searchWrapperBarHeight: number
  ) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href");
    const targetSection = document.querySelector(`#${href?.split("#")[1]}`);
    const targetOffset = targetSection?.getBoundingClientRect().top ?? 0;
    const categoryBarHeight =
      document.querySelector(`#${barId}`)?.getBoundingClientRect().height ?? 0;
    const headerHeight =
      document.querySelector("#_header_wrapper")?.getBoundingClientRect()
        .height ?? 0;
    const previousOrdersBarHeight =
      document.querySelector("#previous_order_bar")?.getBoundingClientRect()
        .height ?? 0;

    window.scrollTo({
      top:
        targetOffset +
        window.pageYOffset -
        categoryBarHeight -
        headerHeight -
        previousOrdersBarHeight -
        searchWrapperBarHeight,
      behavior: "smooth",
    });
  };

  const trackCategoryClick = (categoryId: number) => {
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.CATEGORY_BUTTON, {
      categoryId,
    });
  };

  return {
    isFranchiseOpen,
    isMainDark,
    scrollToCategory,
    trackCategoryClick,
  };
};
